/* eslint-disable no-new */
import axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import TranslatePlugin from '../shared/TranslatePlugin';
import ComponentInitializer from '../shared/ComponentInitializer';
import EventList from './event-list.vue';
import EventDetail from './event-detail.vue';
import EventRegistration from './event-registration.vue';
import EventParticipants from './event-participants.vue';
import MyEvents from './my-events.vue';

Vue.use(VueAxios, axios);
Vue.use(TranslatePlugin);
Vue.config.productionTip = false;

ComponentInitializer.initVueComponents([
  { component: EventList, dataAttribute: 'data-event-list' },
  { component: EventDetail, dataAttribute: 'data-event-detail' },
  { component: EventRegistration, dataAttribute: 'data-event-registration' },
  { component: EventParticipants, dataAttribute: 'data-event-participants' },
  { component: MyEvents, dataAttribute: 'data-my-events' },
]);
